export const calendarEventStyles = {
  calendarEventCard: {
    position: 'relative',
    background: '#f7f8fd',
    borderRadius: '10px',
    border: '1.5px solid #f2f3f5',
    padding: 0,
    minWidth: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    transition:
      'transform 0.15s cubic-bezier(0.4,0,0.2,1), box-shadow 0.15s cubic-bezier(0.4,0,0.2,1), background 0.15s cubic-bezier(0.4,0,0.2,1), color 0.15s cubic-bezier(0.4,0,0.2,1)',
    '&.confirmed-event::before': {
      content: `''`,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '3px',
      height: '100%',
      borderRadius: '10px 0 0 10px',
      background:
        'linear-gradient(to bottom, transparent 0%, #2d54e8 10%, #2d54e8 90%, transparent 100%)',
      zIndex: 2
    },
    '&.confirmed-event': {
      color: '#3946ac',
      background: '#f7f8fd'
    },
    '&.session-over-event': {
      color: '#6b7280',
      background: '#fff',
      '.event-title, .event-time, .event-details': {
        color: '#6b7280'
      }
    },
    '&.selected-event, &:hover': {
      background: '#2563eb',
      boxShadow:
        '0 8px 32px 0 rgba(37,99,235,0.25), 0 1.5px 4px 0 rgba(60,60,120,0.08)',
      transform: 'scale(1.05)',
      transformOrigin: 'center center',
      '.event-title, .event-time, .event-details': {
        color: '#fff'
      }
    }
  },

  eventContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '2px 22px 4px 8px',
    zIndex: 2,
    gap: '2px'
  },

  eventContentShort: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '1px 22px 4px 8px',
    zIndex: 2,
    gap: '2px'
  },

  eventContentMobile: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '2px 8px 4px 8px',
    zIndex: 2,
    gap: '2px'
  },

  eventContentTabletShort: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '6px 22px 4px 8px',
    zIndex: 2,
    gap: '2px'
  },

  eventRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  },

  eventTime: {
    fontSize: '10px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    color: '#2d54e8',
    opacity: 0.8
  },

  eventTitle: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#2d54e8',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'break-spaces'
  },

  googleEventCard: {
    position: 'relative',
    background: '#F2FFF8',
    borderRadius: '10px',
    border: '1.5px solid #2828280D',
    padding: 0,
    minWidth: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    transition:
      'transform 0.15s cubic-bezier(0.4,0,0.2,1), box-shadow 0.15s cubic-bezier(0.4,0,0.2,1), background 0.15s cubic-bezier(0.4,0,0.2,1), color 0.15s cubic-bezier(0.4,0,0.2,1)',
    '&::before': {
      content: `''`,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '3px',
      height: '100%',
      borderRadius: '10px 0 0 10px',
      background:
        'linear-gradient(to bottom, transparent 0%, #6BE19F 10%, #6BE19F 90%, transparent 100%)',
      zIndex: 2
    },
    color: '#0D8443',
    '.event-title, .event-time, .event-details': {
      color: '#0D8443'
    },
    '&.selected-event, &:hover': {
      background: '#2563eb',
      boxShadow:
        '0 8px 32px 0 rgba(37,99,235,0.25), 0 1.5px 4px 0 rgba(60,60,120,0.08)',
      transform: 'scale(1.05)',
      transformOrigin: 'center center',
      color: '#fff',
      '.event-title, .event-time, .event-details': {
        color: '#fff'
      },
      '&::before': {
        background:
          'linear-gradient(to bottom, transparent 0%, #2d54e8 10%, #2d54e8 90%, transparent 100%)'
      }
    }
  },
  googleEventTime: {
    fontSize: '10px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    color: '#0D8443',
    opacity: 0.8
  },
  googleEventTitle: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#0D8443',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'break-spaces'
  },
  icalEventCard: {
    position: 'relative',
    background: '#FFF6F6',
    borderRadius: '10px',
    border: '1.5px solid #2828280D',
    padding: 0,
    minWidth: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    transition:
      'transform 0.15s cubic-bezier(0.4,0,0.2,1), box-shadow 0.15s cubic-bezier(0.4,0,0.2,1), background 0.15s cubic-bezier(0.4,0,0.2,1), color 0.15s cubic-bezier(0.4,0,0.2,1)',
    '&::before': {
      content: `''`,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '3px',
      height: '100%',
      borderRadius: '10px 0 0 10px',
      background:
        'linear-gradient(to bottom, transparent 0%, #EB5164 10%, #EB5164 90%, transparent 100%)',
      zIndex: 2
    },
    color: '#C6162C',
    '.event-title, .event-time, .event-details': {
      color: '#C6162C'
    },
    '&.selected-event, &:hover': {
      background: '#2563eb',
      boxShadow:
        '0 8px 32px 0 rgba(37,99,235,0.25), 0 1.5px 4px 0 rgba(60,60,120,0.08)',
      transform: 'scale(1.05)',
      transformOrigin: 'center center',
      color: '#fff',
      '.event-title, .event-time, .event-details': {
        color: '#fff'
      },
      '&::before': {
        background:
          'linear-gradient(to bottom, transparent 0%, #2d54e8 10%, #2d54e8 90%, transparent 100%)'
      }
    }
  },
  icalEventTime: {
    fontSize: '10px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    color: '#C6162C',
    opacity: 0.8
  },
  icalEventTitle: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#C6162C',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'break-spaces'
  },
  outlookEventCard: {
    position: 'relative',
    background: '#F6F0FA',
    borderRadius: '10px',
    border: '1.5px solid #2828280D',
    padding: 0,
    minWidth: '100%',
    height: '100%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    transition:
      'transform 0.15s cubic-bezier(0.4,0,0.2,1), box-shadow 0.15s cubic-bezier(0.4,0,0.2,1), background 0.15s cubic-bezier(0.4,0,0.2,1), color 0.15s cubic-bezier(0.4,0,0.2,1)',
    '&::before': {
      content: `''`,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '3px',
      height: '100%',
      borderRadius: '10px 0 0 10px',
      background:
        'linear-gradient(to bottom, transparent 0%, #B554F6 10%, #B554F6 90%, transparent 100%)',
      zIndex: 2
    },
    color: '#682992',
    '.event-title, .event-time, .event-details': {
      color: '#682992'
    },
    '&.selected-event, &:hover': {
      background: '#2563eb',
      boxShadow:
        '0 8px 32px 0 rgba(37,99,235,0.25), 0 1.5px 4px 0 rgba(60,60,120,0.08)',
      transform: 'scale(1.05)',
      transformOrigin: 'center center',
      color: '#fff',
      '.event-title, .event-time, .event-details': {
        color: '#fff'
      },
      '&::before': {
        background:
          'linear-gradient(to bottom, transparent 0%, #2d54e8 10%, #2d54e8 90%, transparent 100%)'
      }
    }
  },
  outlookEventTime: {
    fontSize: '10px',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    color: '#682992',
    opacity: 0.8
  },
  outlookEventTitle: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#682992',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    minWidth: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'break-spaces'
  }
}
